/** Startup creation confirmation and startup profile copy. Part of `UI_STRINGS` - see ui-strings.ts. */
export const UI_STARTUP_STRINGS = {
  STARTUP_CREATED: {
    HEADING: 'Your Startup Profile is Live',
    SUBTITLE:
      'Welcome to the My NEXT Raise founder community. Head to your dashboard to manage your profile, invite team members, and explore your new features.',
    GO_TO_DASHBOARD: 'Go to Startup Dashboard',
    VIEW_PROFILE: 'View My Startup',
  },
  STARTUP_PROFILE: {
    ABOUT: 'About',
    DETAILS: 'Company details',
    TEAM: 'Founding team',
    LINKS: 'Links',
    FUNDING_STAGE: 'Funding stage',
    YEAR_FOUNDED: 'Year founded',
    EMPLOYEES: 'Employees',
    RAISE: 'Raise sought',
    INSTRUMENT: 'Instrument',
    MARKET_MODELS: 'Market model',
    MILESTONE: 'Recent milestone',
    SECTOR: 'Sector',
    WEBSITE: 'Website',
    LINKEDIN: 'LinkedIn',
    PITCH_VIDEO: 'Pitch video',
    NOT_PROVIDED: 'Not provided',
    NOT_ADDED: 'Not added',
    EDIT_PROFILE: 'Edit Startup Profile',
    CANCEL: 'Cancel',
    SAVE: 'Save Changes',
    DISCARD: 'Discard Changes',
    SAVING: 'Saving…',
    SAVE_ERROR: 'We could not save your changes. Please try again.',
    SAVE_SUCCESS: 'Your profile changes have been saved.',
    EXPORT_PDF: 'Export as PDF',
    /** Feedback call 2026-10-26: see the profile as an investor will before sharing. */
    PREVIEW_AS_INVESTOR: 'Preview as investor',
    PREVIEW_BANNER: 'Preview: this is how your profile looks to someone you share it with.',
    PREVIEW_BACK: 'Back to your profile',
    PREVIEW_ERROR: 'We could not load the preview. Please try again.',
    EXPORT_PDF_GENERATING: 'Generating PDF…',
    EXPORT_PDF_ERROR: 'We could not export your profile as a PDF. Please try again.',
    FOOTER_NOTE: 'All changes will be saved to your profile',
    CONFIRM_SAVE_TITLE: 'Are You Sure ?',
    CONFIRM_SAVE_BODY: 'You want to save profile changes',
    CONFIRM_SAVE_ACTION: 'Yes, Save Changes',
    COMPANY_OVERVIEW: 'Company Overview',
    COMPANY_NAME: 'Company Name',
    BRIEF_DESCRIPTION: 'Brief Description',
    SUBSECTORS: 'Subsectors',
    HQ_LOCATION: 'HQ Location',
    // Read-only, derived from the HQ country (UX sheet r105).
    HQ_REGION: 'Region',
    RECENT_MILESTONE: 'Recent Milestone',
    COMPANY_WEBSITE: 'Company Website',
    COMPANY_LINKEDIN: 'Company LinkedIn',
    FINANCIALS: 'Financials',
    TOTAL_REVENUE: 'Total Revenue',
    ARR: 'ARR',
    AMOUNT_RAISED_TO_DATE: 'Total Amount Raised to Date',
    NONDILUTIVE_FUNDING: 'Total Non-Dilutive Funding Raised To Date',
    NONDILUTIVE_FUNDING_HINT: 'Amount from non-dilutive funding sources',
    PITCH_MATERIALS: 'Pitch Materials',
    PITCH_DECK: 'Pitch Deck',
    VIEW_PITCH_DECK: 'View Pitch Deck',
    VIEW_PITCH_VIDEO: 'View Pitch Video',
    VIEWABLE_BY_RECIPIENTS: 'Viewable by recipients',
    PITCH_VIDEO_URL: 'Pitch Video Link',
    FOUNDING_TEAM: 'Founding Team',
    MEMBER_TITLE_PREFIX: 'Co-Founder ',
    ADD_MEMBER: 'Add Co-Founder',
    REMOVE_MEMBER: 'Remove',
    PAST_EXIT_PREFIX: 'Past exit: ',
    CURRENT_RAISE: 'Current Raise',
    ROUND_SIZE: 'Round Size',
    TARGET_CLOSE_DATE: 'Target Close Date',
    VALUATION_OR_CAP: 'Valuation or Cap',
    LEAD_INVESTOR: 'Lead Investor',
    LEAD_INVESTOR_NOT_CONFIRMED: 'Not confirmed',
  },
} as const;
